module.exports = __webpack_public_path__ + "img/starLink.146bdcd7.png";